import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-disabled"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "project__likedNumWrap flex justify-center items-center w-[40px] absolute top-[12px] right-[6px] cursor-pointer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["project__liked relative translate-y-[10px]", $setup.ended ? 'pointer-events-none opacity-80' : '']),
    onClick: $setup.handleLike,
    role: "button",
    "aria-disabled": $setup.ended ? 'true' : 'false'
  }, [
    _createElementVNode("img", {
      class: "w-auto h-auto cursor-pointer",
      src: $setup.iconSrc,
      alt: "いいね"
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["project__likedNum txt__osM24", $setup.isWhite ? 'text-white' : 'text-[#7E7E7E]'])
      }, _toDisplayString($setup.displayCount), 3 /* TEXT, CLASS */)
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}